import RegisterFormComponent from '@/components/auth/RegisterForm/RegisterFormComponent';

// Re-export der Formular-Komponente als Default-Export
export default RegisterFormComponent;

// Re-export der Typen für Verwendung in anderen Komponenten
export * from '@/components/auth/RegisterForm/schema';
export * from '@/components/auth/RegisterForm/FormField';

// Re-export von Helper-Komponenten, die möglicherweise von außen benötigt werden
export { PersonalInfoSection } from '@/components/auth/RegisterForm/sections/PersonalInfoSection';
export { AddressSection } from '@/components/auth/RegisterForm/sections/AddressSection';
export { AccountSection } from '@/components/auth/RegisterForm/sections/AccountSection';
export { TermsSection } from '@/components/auth/RegisterForm/sections/TermsSection';
export { RegistrationSuccess } from '@/components/auth/RegisterForm/RegistrationSuccess';

// Re-export des Custom Hooks falls er in anderen Formularen wiederverwendet werden soll
export { useRegisterForm } from '@/components/auth/RegisterForm/hooks/useRegisterForm';